export default "__VITE_ASSET__ux$OQCjJ__"